/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from "react";
import { TextField } from "@mui/material";
import { parsePhoneNumber } from "awesome-phonenumber";

const PhoneTextInput = (props: any, ref: React.Ref<any> | undefined) => {
  const localProps = { ...props };
  let value: string = localProps.value;
  const phone = parsePhoneNumber(value, { regionCode: "SE" });
  if (phone.valid) {
    if (value.substring(0, 3) === "+46") {
      value = value.replace(/^\+46 /, "0");
    }
    if (value.substring(0, 1) !== "0") {
      value = `0${value}`;
    }
    delete localProps.value;
  }
  return (
    <TextField
      {...localProps}
      inputRef={ref}
      fullWidth
      size="small"
      value={localProps.value ?? value}
      variant="standard"
      name="phone"
      margin="dense"
    />
  );
};
export default forwardRef(PhoneTextInput);
